import { useIntlStore as g } from "@dcentralexpedientedigital/fe-shared/stores/intl-store";
import { createTranslationsParams as y, createDeepTranslationsFilter as D, createFiltersOnPath as n, expandDeepSorts as S } from "../utils/directus-localization-filter.js";
function x({
  filtersPath: o = "",
  deepFiltersPaths: e,
  deepSorts: r,
  filterByLocalizedSlug: a,
  slug: l
}) {
  const s = g((t) => t.locale), { filter: i } = y(s), { translations: u } = D(s), f = a && l ? {
    ...n(o, {
      slug: {
        _eq: l
      }
    })
  } : null, m = JSON.stringify({
    _and: [n(o, i), f].filter(Boolean)
  }), c = (e == null ? void 0 : e.reduce((t, d) => {
    const F = n(d, u);
    return { ...t, ...F };
  }, {})) ?? {}, p = r ? {
    ...c,
    ...S(r)
  } : c, O = JSON.stringify(p);
  return {
    filters: m,
    deepFilters: O
  };
}
export {
  x as useLocalizedQueryParams
};
